import React, { useEffect } from 'react';
import { initMetaPixel, initGoogleAnalytics } from './utils/analytics';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials } from './components/Testimonials';
import { ProblemSection } from './components/ProblemSection';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { CountdownTimer } from './components/CountdownTimer';
import { AulaListaSection } from './components/AulaListaSection';
import { ComparisonTable } from './components/ComparisonTable';
import { ComparisonTableExtended } from './components/ComparisonTableExtended';
import { PricingSection } from './components/PricingSection';
import { TestimonialsPreGuarantee } from './components/TestimonialsPreGuarantee';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    initMetaPixel('1687764378881323');
    initGoogleAnalytics('G-59N5WN0RDX');
  }, []);
  return <div className="min-h-screen bg-brand-dark font-sans selection:bg-brand-yellow selection:text-black" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <Testimonials data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <TomosSection data-id="element-5" />
      <BonusSection data-id="element-6" />
      <CountdownTimer data-id="element-7" />
      <PricingSection data-id="element-8" />
      <AulaListaSection data-id="element-9" />
      <ComparisonTableExtended data-id="element-10" />
      <TestimonialsPreGuarantee data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <ComparisonTable data-id="element-14" />
      <FinalCTA data-id="element-15" />
      <PurchasePopup data-id="element-16" />
    </div>;
}